var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table table-widget" }, [
    _c("thead", [
      _c(
        "tr",
        [
          _c("th", [_vm._v(" ")]),
          _vm._v(" "),
          _vm._l(_vm.columns, function(column) {
            return _c("th", { staticClass: "name" }, [_vm._v(_vm._s(column))])
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _vm._l(_vm.dataRows, function(row) {
          return _c(
            "tr",
            [
              _c("td", { staticClass: "name" }, [
                _vm._v(_vm._s(row[_vm.categoryProperty]))
              ]),
              _vm._v(" "),
              _vm._l(_vm.columns, function(column) {
                return _c("td", { staticClass: "data-cell" }, [
                  _vm._v(_vm._s(row[column]))
                ])
              })
            ],
            2
          )
        }),
        _vm._v(" "),
        _vm.finalRowContainsPercentages
          ? _c(
              "tr",
              [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _vm._l(_vm.columns, function(column) {
                  return _c(
                    "td",
                    {
                      staticClass: "percentage-cell",
                      class: _vm.getPercentageClassName(
                        _vm.percentageRow[column]
                      )
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("percentageDisplay")(
                              _vm.percentageRow[column]
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                })
              ],
              2
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }